<template>
    <vx-card no-shadow>
        <div class="flex flex-wrap items-center mb-6">
            <div class="w-2/24">
                <image-uploader
                    :quality="0.7"
                    :preview="false"
                    :className="['fileinput']"
                    capture="environment"
                    :debug="0"
                    doNotResize="gif"
                    :autoRotate="true"
                    outputFormat="verbose"
                    @input="setImage">
                    <label for="fileInput" slot="upload-label">
                        <span class="upload-caption">
                            <vs-avatar id="imageUpload" :src="user.photoURL" size="70px" class="mr-4 mb-4" />
                        </span>
                    </label>
                </image-uploader>
            </div>
            
            <div class="w-9/12 mb-4">
                <vs-button type="border" color="danger" class="mt-5" @click="removePhoto">Remover Foto</vs-button>
                <p class="text-sm mt-2">Recomendado: 512x512 </p>
            </div>
        </div>

        

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4">
            <vs-input v-validate="{required : true}" name="full_name" class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="NOME COMPLETO" placeholder="Ex.: Maria Aparecida da Penha" v-model="user.name"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('full_name')">{{ errors.first('full_name') }}</span>
        </div>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 m mb-4">
            <vs-input v-validate="{regex: /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/}" name="cpf" v-mask="'###.###.###-##'" class="w-full" icon-pack="feather" icon="icon-credit-card" icon-no-border label="CPF" placeholder="123.456.789.99" v-model="user.cpf"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('cpf')">{{ errors.first('cpf') }}</span>
        </div>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 m mb-4">
            <vs-input v-validate="{regex: /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3} [0-9]{4}$/}" name="celular" v-mask="'(##) ##### ####'" class="w-full" icon-pack="feather" icon="icon-smartphone" icon-no-border label="CELULAR" placeholder="(00) 9 9999 9999" v-model="user.phone"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('celular')">{{ errors.first('celular') }}</span>
        </div>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 m mb-4">
            <vs-input disabled v-validate="{email: true}" name="email" class="w-full" icon-pack="feather" icon="icon-at-sign" icon-no-border label="EMAIL" placeholder="nome@hotmail.com" v-model="email"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>

        <vs-divider border-style="dashed" class="mt-8 text-danger" > Notificações do Sistema </vs-divider>
        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4">
            <vs-checkbox v-model="user.notify.newBill"> Nova Mesa </vs-checkbox>
            <span class="text-sm text-danger" style="position: relative; left: 32px"> Será avisado sempre que uma nova mesa for aberta </span>
        </div>
        <!-- <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4">
            <vs-checkbox v-model="user.notify.waiter"> Solicitação de Garçom  </vs-checkbox>
            <span class="text-danger text-sm" v-show="errors.has('full_name')">{{ errors.first('full_name') }}</span>
        </div> -->
        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4">
            <vs-checkbox v-model="user.notify.newOrder"> Novo Pedido </vs-checkbox>
            <span class="text-sm text-danger" style="position: relative; left: 32px"> Será avisado sempre que for feito um novo pedido </span>
        </div>
        <vs-divider border-style="dashed"  class="mb-8" />

        <!-- <vs-alert icon-pack="feather" icon="icon-info" class="h-full my-4" color="warning">
            <span>Sua conta não está verificada. <a href="#" class="hover:underline">Reenviar confirmação</a></span>
        </vs-alert> -->

        <div class="flex flex-wrap">
            <vs-button class="mt-2" @click="save">Salvar Alterações</vs-button>
        </div>
    </vx-card>
</template>

<script>
import firebase from '@/firebase/firebase'
import {mask} from 'vue-the-mask'
import {Validator} from 'vee-validate'
import _misc from '@/assets/utils/misc.js'
import ImageUploader from 'vue-image-upload-resize'

const dict = {
    custom: {
        phone: {
            regex: 'Preencha o número de celular corretamente'
        },
        full_name: {
            required: 'Entre com o seu nome e sobrenome'
        },
        cpf: {
            regex: 'CPF inválido'
        },
        email: {
            email: 'Entre com um email válido'
        }
    }
}

Validator.localize('en', dict)

export default {
    directives : {mask},

    components : {
        ImageUploader
    },

    data () {
        return {
            email: '',
            user : {
                name : 'junior guere',
                cpf: '',
                phone: '',
                photoURL: '',
                root : false,
                notify : {
                    newBill  : false,
                    help     : true,
                    newOrder : false
                }
            },
            noPhotoURL : ''
        }
    },

    mounted () {
        let activeUserInfo = this.$store.getters.getUserStoredData
        this.$set(this.user, 'name',  activeUserInfo.name)
        this.$set(this.user, 'cpf',   activeUserInfo.cpf)
        this.$set(this.user, 'phone', activeUserInfo.phone)
        this.$set(this.user, 'photoURL', activeUserInfo.photoURL)

        if(activeUserInfo.hasOwnProperty('notify')) {
            this.$set(this.user.notify, 'newBill', activeUserInfo.notify.newBill)
            // this.$set(this.user.notify, 'waiter', activeUserInfo.notify.waiter)
            this.$set(this.user.notify, 'newOrder', activeUserInfo.notify.newOrder)
        }
        this.email = activeUserInfo.email;

        // this.$message.config({ top: '80px' })

        this.$validator.validateAll()
    },

    async created () {
        this.getNoPhotoURL()
    },

    watch : {
        user : {
            handler(prop) {
                this.namesToUpper()
            },
            deep: true
        }
    },

    methods : {
        setImage (output) {
            var that = this
            var imageName   = _misc.generateId(50);
            let storageRef  = firebase.storage().ref().child(`users/photos/${imageName}`)
            let uploadTask  = storageRef.putString(output.dataUrl, 'data_url');

            uploadTask.on('state_changed', function (snapshot) {
                    that.$vs.loading({
                        scale: 0.5,
                        container : "#imageUpload"
                    })
                }, function(err) {
                    that.$vs.loading.close('#imageUpload > .con-vs-loading');
                    that.$vs.dialog({
                        type: 'alert',
                        title: 'erro',
                        text: `Erro ao efetuar upload da imagem: ${err}`,
                        acceptText: 'Fechar'
                    })
                }, async function () {
                    let url = await uploadTask.snapshot.ref.getDownloadURL()
                    that.user.photoURL = url

                    that.$vs.loading.close('#imageUpload > .con-vs-loading');
                }
            )
        },

        async getNoPhotoURL () {
            let storageRef  = firebase.storage().ref().child(`users/photos/no-photo.png`)
            let photoURL    = await storageRef.getDownloadURL()
            this.noPhotoURL = photoURL;
        },

        removePhoto () {
            this.$set(this.user, 'photoURL', this.noPhotoURL)
        },

        namesToUpper () {           
            this.user.name = String(this.user.name).split(' ').map((a) => {
                if (typeof(a[0]) != 'undefined') return a[0].toUpperCase() + a.slice(1, a.length)
            }).join(' ');
        },

        async save () {
            let validator = await this.$validator.validateAll()
            if(!validator) return

            if(!_misc.validateCPF(this.user.cpf) && this.user.cpf) {
                this.$vs.dialog({
                    type: 'alert',
                    title: 'Erro de validação',
                    text: 'O CPF informado é inválido.',
                    acceptText: 'Vou corrigir'
                })
                return
            }
            
            this.updateInfoOnFB()
        },

        async updateInfoOnFB() {
            try {
                let companyId  = this.$store.getters.getCompanyID
                let userId     = this.$store.getters.getUserStoredData.uid
                if (typeof(companyId) == 'undefined') throw new Error('Empresa desconhecida!');
                
                this.$vs.loading()
                // await firebase.firestore().collection('company').doc(companyId).collection('companyUsers').doc(userId).update(this.user)
                // await firebase.firestore().collection('user').doc(userId).update(this.user, { merger : true })

                // companies = await firebase.firestore().collection('')
                const ref = await firebase.firestore().collectionGroup('companyUsers')
                                                .where('uid', '==', userId)
                                                .get()
                let batch = firebase.firestore().batch()
                ref.docs.forEach(doc => {
                    companyId = doc.ref.parent.parent.id
                    const refDoc = firebase.firestore().collection(`/company/${companyId}/companyUsers`).doc(userId)
                    batch.update(refDoc, this.user, { merger : true }) 
                })

                await batch.commit()
                
                this.updateAppState()

                this.$message.success('Informações alteradas com sucesso!', 5)
            } catch (err) {
                this.$vs.dialog({ 
                    type: 'alert',
                    title: 'Erro grave', 
                    text: `Houve um erro inesperado ao atualizar os dados: ${err.message}`,
                    acceptText : 'Fechar'
                })
            } finally {
                this.$vs.loading.close()
            }
        },

        updateAppState () {
            this.$store.dispatch('updateUserName', this.user.name);
            this.$store.dispatch('updateUserCPF', this.user.cpf);
            this.$store.dispatch('updateUserPhone', this.user.phone);
            this.$store.dispatch('updateUserPhoto', this.user.photoURL);
            this.$store.dispatch('updateUserNotifyOrders', this.user.notify.newOrder);
            this.$store.dispatch('updateUserNotifyBill', this.user.notify.newBill);
            // this.$store.dispatch('updateUserNotifyWaiter', this.user.notify.waiter);
        }
    }
}
</script>

<style>
    #fileInput {
        display: none;
    }
</style>